function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { View } from "react-native";
import Select from "react-select";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";
const configJSON = require("./config");
export default class CountryCodeSelector extends BlockComponent {
  // Customizable Area Start

  // Customizable Area End
  constructor(props) {
    super(props);

    // Customizable Area Start
    _defineProperty(this, "countryCodesToDropDown", data => {
      return data.map(item => ({
        label: " ".concat(item.attributes.emoji_flag, " ").concat(item.attributes.name, " (").concat(item.id, ") +").concat(item.attributes.country_code),
        value: item.attributes.country_code
      }));
    });
    _defineProperty(this, "makeRemoteRequest", () => {
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      this.countryCodeApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.apiEndPointGetCountryCodes);
      const header = {
        "Content-Type": configJSON.contentTypeApiGetCountryCodes
      };
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.apiGetCountryCodesType);
      runEngine.sendMessage(requestMessage.id, requestMessage);
    });
    this.subScribedMessages = [getName(MessageEnum.RestAPIResponceMessage)];
    this.receive = this.receive.bind(this);
    this.handleChange = this.handleChange.bind(this);
    runEngine.attachBuildingBlock(this, this.subScribedMessages);
    this.state = {
      dataSource: [],
      countryCodeSelected: "",
      mobileNo: "",
      token: "",
      placeHolder: configJSON.countryPlaceHolder,
      disable: this.props.disable,
      label: null
    };
    // Customizable Area End
  }
  render() {
    // Customizable Area Start
    var index = -1;
    var iIndex = -1;
    this.state.dataSource.forEach(item => {
      iIndex += 1;
      if (item.value === this.props.value) {
        index = iIndex;
        return;
      }
    });
    return /*#__PURE__*/React.createElement(View, {
      style: {
        marginBottom: 10,
        zIndex: 99
      }
    }, /*#__PURE__*/React.createElement(Select, {
      style: this.props.style,
      options: this.state.dataSource,
      placeholder: this.state.placeHolder,
      onChange: this.handleChange,
      value: index >= 0 ? this.state.dataSource[index] : null,
      isDisabled: this.state.disable
    }));
    // Customizable Area End
  }

  // Customizable Area Start
  handleChange(item) {
    this.setState({
      label: item.label
    });
    const msg = new Message(getName(MessageEnum.CountryCodeMessage));
    msg.addData(getName(MessageEnum.CountyCodeDataMessage), item.value);
    runEngine.sendMessage(getName(MessageEnum.CountryCodeMessage), msg);
  }
  async componentDidMount() {
    this.makeRemoteRequest();
  }
  async receive(from, message) {
    runEngine.debugLog("Country Code", message);
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id && this.countryCodeApiCallId != null && this.countryCodeApiCallId === message.getData(getName(MessageEnum.RestAPIResponceDataMessage))) {
      var responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));

      //
      if (responseJson && !responseJson.errors) {
        this.setState({
          dataSource: this.countryCodesToDropDown(responseJson.data)
        });
      } else {
        var errorReponse = message.getData(getName(MessageEnum.RestAPIResponceErrorMessage));
        this.parseApiCatchErrorResponse(errorReponse);
      }
    }
  }

  // Customizable Area End
}